import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    createLetterAPIHelper,
    createTemplateAPIHelper,
    deleteLetterAPIHelper,
    deleteTemplateAPIHelper,
    getLetterByIdAPIHelper,
    getLettersAPIHelper,
    getTemplateByIdAPIHelper,
    getTemplatesAPIHelper,
    updateLetterAPIHelper,
    updateTemplateAPIHelper,
    getIssuedLogsAPIHelper,
    getPublicLetterAPIHelper,
    submitExternalSignatureAPIHelper,
    sendSigningLinkAPIHelper,
    initiateESignAPIHelper,
    verifyESignAPIHelper
} from "../helpers/letterheadAPI.ts";

interface LetterHeadState {
    templates: Object[] | null;
    template: Object | null;
    letters: Object[] | null;
    letter: Object | null;
    issuedLogs: Object[] | null;
    cid: string | null;
    loading: boolean;
    error: any;
    publicLetter: Object | null;
}

const initialState: LetterHeadState = {
    templates: [],
    template: null,
    letters: [],
    issuedLogs: [],
    letter: null,
    cid: null,
    loading: false,
    error: null,
    publicLetter: null,
};

// ================= TEMPLATE THUNKS =================
export const createTemplate = createAsyncThunk(
    "/letterHead/createTemplate",
    async (payload: any, thunkAPI) => {
        try {
            const response = await createTemplateAPIHelper(payload);
            thunkAPI.dispatch(getTemplates());
            return response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const getTemplates = createAsyncThunk(
    "/letterHead/getTemplates",
    async (cid:any, thunkAPI) => {
        const state: any = thunkAPI.getState();
        // const cid = state.company.cid;
        try {
            return await getTemplatesAPIHelper(cid);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getTemplateById = createAsyncThunk(
    "/letterHead/getTemplateById",
    async (id: string, thunkAPI) => {
        try {
            return await getTemplateByIdAPIHelper(id);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const updateTemplate = createAsyncThunk(
    "/letterHead/updateTemplate",
    async (payload: any, thunkAPI) => {
        try {
            const response = await updateTemplateAPIHelper(payload);
            thunkAPI.dispatch(getTemplates());
            return response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteTemplate = createAsyncThunk(
    "/letterHead/deleteTemplate",
    async (id: string | number, thunkAPI) => {
        try {
            return await deleteTemplateAPIHelper(id);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

// ================= LETTER THUNKS =================

export const createLetter = createAsyncThunk(
    "/letterHead/createLetter",
    async (payload: any, thunkAPI) => {
        try {
            const response = await createLetterAPIHelper(payload);
            thunkAPI.dispatch(getLetters());
            return response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getLetters = createAsyncThunk(
    "/letterHead/getLetters",
    async (payload, thunkAPI) => {
        // const state: any = thunkAPI.getState();
        // const cid = state.company.cid;
        console.log("AM REDUCERPAYLOAD", payload)
        try {
            return await getLettersAPIHelper(payload);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getLetterById = createAsyncThunk(
    "/letterHead/getLetterById",
    async (id: string, thunkAPI) => {
        try {
            return await getLetterByIdAPIHelper(id);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const updateLetter = createAsyncThunk(
    "/letterHead/updateLetter",
    async (payload: any, thunkAPI) => {
        try {
            const response = await updateLetterAPIHelper(payload);
            thunkAPI.dispatch(getLetters());
            return response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteLetter = createAsyncThunk(
    "/letterHead/deleteLetter",
    async (id: string, thunkAPI) => {
        try {
            const response = await deleteLetterAPIHelper(id);
            thunkAPI.dispatch(getLetters());
            return response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

//  Fetch Audit Logs
export const getIssuedLogs = createAsyncThunk(
    "/letterHead/getIssuedLogs",
    async (payload, thunkAPI) => {
        // const state: any = thunkAPI.getState();
        // const cid = state.company.cid;
        try {
            return await getIssuedLogsAPIHelper(payload);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);


//  EXTERNAL SIGNING
export const getPublicLetter = createAsyncThunk(
    "/letterHead/getPublicLetter",
    async (id: string, thunkAPI) => {
        try {
            return await getPublicLetterAPIHelper(id);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const submitExternalSignature = createAsyncThunk(
    "/letterHead/submitExternalSignature",
    async (payload: { id: string,token: string, formData: FormData }, thunkAPI) => {
        try {
           return await submitExternalSignatureAPIHelper(payload.id, payload.token, payload.formData);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);



// ================= ESIGN THUNKS =================
export const initiateESign = createAsyncThunk(
    "/letterHead/initiateESign",
    async (_, thunkAPI) => {
        try {
            return await initiateESignAPIHelper();
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

// Replace your verifyESign thunk with this:
export const verifyESign = createAsyncThunk(
    "/letterHead/verifyESign",
    async (payload: { code: string, code_verifier: string }, thunkAPI) => {
        try {
            return await verifyESignAPIHelper(payload);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const sendLetterforSignature = createAsyncThunk(
    "/letterHead/send-signature",
    async (payload :any, thunkAPI) => {
        try {
            return await sendSigningLinkAPIHelper(payload);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

const letterHeadSlice = createSlice({
    name: "letterHead",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            /* ================= TEMPLATE STATE UPDATES ================= */

            .addCase(getTemplates.fulfilled, (state, action) => {
                console.log("getTemplates.fulfilled", action.payload);
                state.templates = action.payload;
            })

            .addCase(createTemplate.fulfilled, (state, action) => {
                console.log("createTemplate.fulfilled", action.payload);
                // state.templates = action.payload;
            })

            .addCase(getTemplateById.fulfilled, (state, action) => {
                console.log("getTemplateById.fulfilled", action.payload);
                state.template = action.payload;
            })

            //  UPDATE TEMPLATE IN STATE
            .addCase(updateTemplate.fulfilled, (state, action) => {
                console.log("updateTemplate.fulfilled", action.payload);
            })

            // DELETE TEMPLATE FROM STATE
            .addCase(deleteTemplate.fulfilled, (state, action) => {
                console.log("deleteTemplate.fulfilled", action.payload);
            })

            /* ================= LETTER STATE UPDATES ================= */
            .addCase(createLetter.fulfilled, (state, action) => {
                // state.letters = action.payload;
                console.log("createLetter.fulfilled", action.payload);

            })

            .addCase(getLetters.fulfilled, (state, action) => {
                console.log("getLetters.fulfilled", action.payload);
                state.letters = action.payload;
            })

            .addCase(getLetterById.fulfilled, (state, action) => {
                console.log("getLetterById.fulfilled", action.payload);
                state.letter = action.payload;
            })

            //  UPDATE LETTER
            .addCase(updateLetter.fulfilled, (state, action) => {
                console.log("updateLetter.fulfilled", action.payload);
            })

            //  DELETE LETTER
            .addCase(deleteLetter.fulfilled, (state, action) => {
                console.log("deleteLetter.fulfilled", action.payload);
            })
            .addCase(getIssuedLogs.fulfilled, (state, action) => {
                console.log("getIssuedLogs.fulfilled", action.payload);
                state.issuedLogs = action.payload; 
            })
            .addCase(getPublicLetter.fulfilled, (state, action) => {
                console.log("getPublicLetter.fulfilled", action.payload);
                state.publicLetter = action.payload; 
            })
            .addCase(sendLetterforSignature.fulfilled, (state, action) => {
                console.log("sendLetterforSignature.fulfilled", action.payload);
            })


            /* ================= GLOBAL MATCHERS ================= */
            .addMatcher(
                (action) => action.type.endsWith("/pending"),
                (state, action) => {
                    console.log(action.type);
                    state.loading = true;
                    state.error = null;
                }
            )
            .addMatcher(
                (action) => action.type.endsWith("/rejected"),
                (state, action: any) => {
                    console.log(action.type, action.payload);
                    state.loading = false;
                    state.error = action.payload || "Something went wrong";
                }
            )
            .addMatcher(
                (action) => action.type.endsWith("/fulfilled"),
                (state) => {
                    state.loading = false;
                }
            );
            
    }

});

export const { } = letterHeadSlice.actions;
export default letterHeadSlice.reducer;